/**
 * Build-time configuration injected by webpack's DefinePlugin.
 *
 * `__BUILD_CONFIG__` and `__IS_SERVER__` are replaced at build time (see
 * webpack.config.js). On the server, `__SERVER_RUNTIME_CONFIG__` may override
 * API routing without a rebuild.
 */

export interface BuildConfig {
  wsPort: number;
  apiPort: number;
  nodePort: number;
  apiBaseUrl: string;
  enableDebugLogging: boolean;
  isDevelopment: boolean;
  /** Cache-buster for assets webpack does not content-hash (the xpra client). */
  assetVersion: string;
}

declare const __BUILD_CONFIG__: BuildConfig;
declare const __IS_SERVER__: boolean;

export const buildConfig: BuildConfig = __BUILD_CONFIG__;
export const isServer: boolean = __IS_SERVER__;

export function debugLog(...args: unknown[]): void {
  if (buildConfig.enableDebugLogging) {
    // eslint-disable-next-line no-console
    console.log('[instamouse]', ...args);
  }
}
